import styled from "styled-components";

export default styled.div`
  border-radius: 5px;

  box-sizing: border-box;
  max-width: 800px;
  background: #f9eed2;
  opacity: ${props => (props.open ? 1 : 0)};
  left: 0;
  margin: 0 0 20px;
  transition: opacity 350ms ease-in;
  transition-delay: 0.2s;

  position: relative;
  z-index: 2;
  right: 0;
  top: 0;

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/CustomDialog/DialogContent.js